(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[491],{

/***/ 935:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/join-the-evry-network",
      function () {
        return __webpack_require__(9625);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_SEO_SEO__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3976);
/* harmony import */ var _components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7902);
/* harmony import */ var _components_RadioInput_RadioInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1427);
/* harmony import */ var _components_TextInputArea_TextInputArea__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3487);
/* harmony import */ var _components_FormSuccessDialog_FormSuccessDialog__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1987);
/* harmony import */ var _components_FormErrorDialog_FormErrorDialog__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(299);
/* harmony import */ var _layout_Layout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9875);
/* harmony import */ var _mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(8456);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3448);
/* harmony import */ var _styles_section_module_css__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(3538);
/* harmony import */ var _styles_section_module_css__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_styles_section_module_css__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _hooks_useReportError__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9653);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8148);
/* harmony import */ var _utils_recaptcha__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(3575);
/* harmony import */ var _components_Recaptcha_RecaptchaModal__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4559);
/* harmony import */ var _hooks_useRecaptchaLoader__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2219);























// Common validations
var phoneRegex = /^\d{10,20}$/;
var zipRegex = /^\d{5}$/;
var npiRegex = /^\d{10}$/;
var tinRegex = /^\d{9}$/;
// Helper function to transform empty strings to null
var emptyStringToNull = zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().transform(function(val) {
    return val.trim() === "" ? null : val;
});
// Schema for Network Support form
var networkFormSchema = zod__WEBPACK_IMPORTED_MODULE_13__/* .object */ .Ry({
    practice_group: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().min(1, "Practice Group is required"),
    first_name: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().min(1, "Provider First Name is required"),
    last_name: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().min(1, "Provider Last Name is required"),
    specialty: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().min(1, "Specialty is required"),
    date_of_birth: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().min(1, "Date of Birth is required"),
    email_address: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().email("Invalid email address"),
    provider_npi: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().regex(npiRegex, "Provider NPI must be exactly 10 digits"),
    billing_tin: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().regex(tinRegex, "Tax ID must be exactly 9 digits"),
    group_npi: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().regex(npiRegex, "Group NPI must be exactly 10 digits"),
    billing_address_1: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().min(1, "Billing Address 1 is required"),
    billing_address_2: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().optional().nullable(),
    billing_city: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().min(1, "Billing City is required"),
    billing_state: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().min(1, "Billing State is required"),
    billing_zip: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().regex(zipRegex, "Billing ZIP must be exactly 5 digits"),
    billing_phone: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().regex(phoneRegex, "Billing phone must be between 10 and 20 digits"),
    fax: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().regex(phoneRegex, "Fax number must be between 10 and 20 digits"),
    affiliated_hospitals: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().min(1, "Hospital Affiliations is required"),
    servicing_address_1: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().min(1, "Service Address 1 is required"),
    servicing_address_2: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().optional().nullable(),
    servicing_city: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().min(1, "Service City is required"),
    servicing_state: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().min(1, "Service State is required"),
    servicing_zip: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().regex(zipRegex, "Service ZIP must be exactly 5 digits"),
    license_no: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().min(1, "License Number is required"),
    license_exp: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().min(1, "License Expiration Date is required"),
    dea_no: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().optional().nullable(),
    effective_date: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().min(1, "Effective Date is required"),
    additional_details: zod__WEBPACK_IMPORTED_MODULE_13__/* .string */ .Z_().optional().nullable()
}).transform(function(data) {
    var optionalFields = [
        "dea_no",
        "billing_address_2",
        "servicing_address_2",
        "additional_details", 
    ];
    var transformedData = Object.entries(data).reduce(function(acc, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        var isValueEmptyOrNull = (value === null || value === void 0 ? void 0 : value.trim()) === "" || value == null;
        if (isValueEmptyOrNull) {
            acc[key] = optionalFields.includes(key) ? "N/A" : null;
        } else {
            acc[key] = value;
        }
        return acc;
    }, {});
    return transformedData;
});
var NetworkSupportForm = function(param) {
    var disabledField = param.disabledField, setDisabledField = param.setDisabledField, isSubmitting = param.isSubmitting, setIsSubmitting = param.setIsSubmitting, showError = param.showError, setShowError = param.setShowError, showSuccess = param.showSuccess, setShowSuccess = param.setShowSuccess, reportError = param.reportError;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        practice_group: "",
        first_name: "",
        last_name: "",
        specialty: "",
        date_of_birth: "",
        provider_npi: "",
        billing_tin: "",
        group_npi: "",
        email_address: "",
        billing_address_1: "",
        billing_address_2: "",
        billing_city: "",
        billing_state: "",
        billing_zip: "",
        billing_phone: "",
        fax: "",
        affiliated_hospitals: "",
        servicing_address_1: "",
        servicing_address_2: "",
        servicing_city: "",
        servicing_state: "",
        servicing_zip: "",
        license_no: "",
        license_exp: "",
        dea_no: "",
        effective_date: "",
        additional_details: ""
    }), formData = ref[0], setFormData = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), validationErrors = ref1[0], setValidationErrors = ref1[1];
    var handleChange = function(field, value) {
        setFormData(function(prev) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, field, value));
        });
    };
    var validateForm = function() {
        try {
            var result = networkFormSchema.safeParse(formData);
            if (result.success) {
                return {
                    errors: {},
                    data: result.data
                };
            }
            var errors = result.error.errors.reduce(function(acc, curr) {
                acc[curr.path[0]] = curr.message;
                return acc;
            }, {});
            return {
                errors: errors,
                data: null
            };
        } catch (error) {
            console.error("Validation error:", error);
            return {
                errors: {
                    form: "An error occurred during validation. Please check your entries."
                },
                data: null
            };
        }
    };
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function(e) {
            var ref, errors, parsedData, token, err, payload, response, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        ref = validateForm(), errors = ref.errors, parsedData = ref.data;
                        if (Object.keys(errors).length > 0 || !parsedData) {
                            setValidationErrors(errors);
                            return [
                                2
                            ];
                        }
                        setValidationErrors({});
                        setDisabledField(true);
                        setIsSubmitting(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,_utils_recaptcha__WEBPACK_IMPORTED_MODULE_20__/* .getRecaptchaV3Token */ .o)("request_to_join")
                        ];
                    case 2:
                        token = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        setShowError(true);
                        setDisabledField(false);
                        setIsSubmitting(false);
                        return [
                            2
                        ];
                    case 4:
                        payload = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, parsedData), {
                            captcha_token: {
                                token: token,
                                version: "v3",
                                provider: 1
                            }
                        });
                        response = null;
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            7,
                            ,
                            9
                        ]);
                        return [
                            4,
                            fetch("".concat(_constants__WEBPACK_IMPORTED_MODULE_10__/* .BASE_URL */ ._, "/Marketing/RequestToJoin"), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify(payload)
                            })
                        ];
                    case 6:
                        response = _state.sent();
                        return [
                            3,
                            9
                        ];
                    case 7:
                        error = _state.sent();
                        setShowError(true);
                        return [
                            4,
                            reportError(error)
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            9
                        ];
                    case 9:
                        if (response && response.status === 400) {
                            // server wants v2 verification
                            setPendingSubmitData(payload);
                            setShowCheckboxFallback(true);
                            setDisabledField(false);
                            setIsSubmitting(false);
                            return [
                                2
                            ];
                        }
                        if (!(response && (response === null || response === void 0 ? void 0 : response.status))) return [
                            3,
                            12
                        ];
                        if (!(response.status < 200 || response.status > 299)) return [
                            3,
                            11
                        ];
                        setShowError(true);
                        return [
                            4,
                            reportError(response)
                        ];
                    case 10:
                        _state.sent();
                        return [
                            3,
                            12
                        ];
                    case 11:
                        setShowSuccess(true);
                        _state.label = 12;
                    case 12:
                        setDisabledField(false);
                        setIsSubmitting(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showCheckboxFallback = ref2[0], setShowCheckboxFallback = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), pendingSubmitData = ref3[0], setPendingSubmitData = ref3[1];
    var handleCheckboxVerify = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function(token) {
            var response;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!pendingSubmitData) return [
                            2
                        ];
                        setShowCheckboxFallback(false);
                        setDisabledField(true);
                        setIsSubmitting(true);
                        return [
                            4,
                            fetch("".concat(_constants__WEBPACK_IMPORTED_MODULE_10__/* .BASE_URL */ ._, "/Marketing/RequestToJoin"), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, pendingSubmitData), {
                                    captcha_token: {
                                        token: token,
                                        version: "v2",
                                        provider: 1
                                    }
                                }))
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        setPendingSubmitData(null);
                        if (response.status >= 200 && response.status <= 299) {
                            setShowSuccess(true);
                        } else {
                            setShowError(true);
                        }
                        setDisabledField(false);
                        setIsSubmitting(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCheckboxVerify(token) {
            return _ref.apply(this, arguments);
        };
    }();
    var renderInput = function(field, label) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "col-span-1 md:col-span-2",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, options), {
                disabled: disabledField,
                value: formData[field],
                change: function(e) {
                    return handleChange(field, e.target.value);
                },
                error: validationErrors[field],
                children: label
            }))
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                onSubmit: handleSubmit,
                className: "grid grid-cols-1 p-2 md:grid-cols-2 text-grey bg-grey-light",
                children: [
                    Object.keys(validationErrors).length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2 mb-6",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex p-4 bg-[#ffe6e6] border-l-4 border-red-700",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex-shrink-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                        className: "w-5 h-5 text-red-700",
                                        fill: "currentColor",
                                        viewBox: "0 0 20 20",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
                                            clipRule: "evenodd"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "ml-3",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-lg font-medium text-red-700",
                                            children: "Please check your entries"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mt-2 text-sm text-red-700",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                className: "list-disc list-inside space-y-1",
                                                children: Object.values(validationErrors).map(function(error, index) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                        children: error
                                                    }, index);
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.practice_group,
                            change: function(e) {
                                return handleChange("practice_group", e.target.value);
                            },
                            error: validationErrors.practice_group,
                            children: "Practice Group"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.first_name,
                            change: function(e) {
                                return handleChange("first_name", e.target.value);
                            },
                            error: validationErrors.first_name,
                            children: "Provider First Name"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.last_name,
                            change: function(e) {
                                return handleChange("last_name", e.target.value);
                            },
                            error: validationErrors.last_name,
                            children: "Provider Last Name"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.email_address,
                            change: function(e) {
                                return handleChange("email_address", e.target.value);
                            },
                            error: validationErrors.email_address,
                            children: "Email Address"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.specialty,
                            change: function(e) {
                                return handleChange("specialty", e.target.value);
                            },
                            error: validationErrors.specialty,
                            children: "Specialty"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            type: "date",
                            disabled: disabledField,
                            value: formData.date_of_birth,
                            change: function(e) {
                                return handleChange("date_of_birth", e.target.value);
                            },
                            error: validationErrors.date_of_birth,
                            children: "Date of Birth"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.provider_npi,
                            change: function(e) {
                                return handleChange("provider_npi", e.target.value);
                            },
                            error: validationErrors.provider_npi,
                            children: "Provider NPI"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.billing_tin,
                            change: function(e) {
                                return handleChange("billing_tin", e.target.value);
                            },
                            error: validationErrors.billing_tin,
                            children: "Tax ID (TIN)"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.group_npi,
                            change: function(e) {
                                return handleChange("group_npi", e.target.value);
                            },
                            error: validationErrors.group_npi,
                            children: "Group NPI"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.billing_address_1,
                            change: function(e) {
                                return handleChange("billing_address_1", e.target.value);
                            },
                            error: validationErrors.billing_address_1,
                            children: "Billing Address 1"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            disabled: disabledField,
                            value: formData.billing_address_2,
                            change: function(e) {
                                return handleChange("billing_address_2", e.target.value);
                            },
                            error: validationErrors.billing_address_2,
                            children: "Billing Address 2"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.billing_city,
                            change: function(e) {
                                return handleChange("billing_city", e.target.value);
                            },
                            error: validationErrors.billing_city,
                            children: "Billing City"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.billing_state,
                            change: function(e) {
                                return handleChange("billing_state", e.target.value);
                            },
                            error: validationErrors.billing_state,
                            children: "Billing State"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.billing_zip,
                            change: function(e) {
                                return handleChange("billing_zip", e.target.value);
                            },
                            error: validationErrors.billing_zip,
                            children: "Billing ZIP"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.billing_phone,
                            change: function(e) {
                                return handleChange("billing_phone", e.target.value);
                            },
                            error: validationErrors.billing_phone,
                            children: "Billing Phone"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.fax,
                            change: function(e) {
                                return handleChange("fax", e.target.value);
                            },
                            error: validationErrors.fax,
                            children: "Fax #"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.affiliated_hospitals,
                            change: function(e) {
                                return handleChange("affiliated_hospitals", e.target.value);
                            },
                            error: validationErrors.affiliated_hospitals,
                            children: "Hospital Affiliations"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.servicing_address_1,
                            change: function(e) {
                                return handleChange("servicing_address_1", e.target.value);
                            },
                            error: validationErrors.servicing_address_1,
                            children: "Service Address 1"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            disabled: disabledField,
                            value: formData.servicing_address_2,
                            change: function(e) {
                                return handleChange("servicing_address_2", e.target.value);
                            },
                            error: validationErrors.servicing_address_2,
                            children: "Service Address 2"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.servicing_city,
                            change: function(e) {
                                return handleChange("servicing_city", e.target.value);
                            },
                            error: validationErrors.servicing_city,
                            children: "Service City"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.servicing_state,
                            change: function(e) {
                                return handleChange("servicing_state", e.target.value);
                            },
                            error: validationErrors.servicing_state,
                            children: "Service State"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.servicing_zip,
                            change: function(e) {
                                return handleChange("servicing_zip", e.target.value);
                            },
                            error: validationErrors.servicing_zip,
                            children: "Service ZIP"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            disabled: disabledField,
                            value: formData.license_no,
                            change: function(e) {
                                return handleChange("license_no", e.target.value);
                            },
                            error: validationErrors.license_no,
                            children: "License #"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            type: "date",
                            disabled: disabledField,
                            value: formData.license_exp,
                            change: function(e) {
                                return handleChange("license_exp", e.target.value);
                            },
                            error: validationErrors.license_exp,
                            children: "License Expiration Date"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            disabled: disabledField,
                            value: formData.dea_no,
                            change: function(e) {
                                return handleChange("dea_no", e.target.value);
                            },
                            error: validationErrors.dea_no,
                            children: "DEA # (Optional)"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInput_TextInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            required: true,
                            type: "date",
                            disabled: disabledField,
                            value: formData.effective_date,
                            change: function(e) {
                                return handleChange("effective_date", e.target.value);
                            },
                            error: validationErrors.effective_date,
                            title: "The date you would like to start seeing Evry Health members",
                            children: "Effective Date"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextInputArea_TextInputArea__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            disabled: disabledField,
                            value: formData.additional_details,
                            change: function(e) {
                                return handleChange("additional_details", e.target.value);
                            },
                            error: validationErrors.additional_details,
                            children: "Additional Details"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 mx-auto my-8 md:col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            type: "submit",
                            disabled: isSubmitting,
                            className: "flex items-center gap-2 px-12 py-2 text-lg font-medium text-white bg-blue disabled:opacity-50 disabled:cursor-not-allowed",
                            children: [
                                isSubmitting && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    size: "1.5rem"
                                }),
                                "Send"
                            ]
                        })
                    })
                ]
            }),
            showCheckboxFallback && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: {
                    position: "fixed",
                    inset: 0,
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            background: "rgba(0,0,0,0.5)",
                            position: "absolute",
                            inset: 0
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        style: {
                            zIndex: 10000,
                            background: "#fff",
                            padding: 20,
                            borderRadius: 8
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                style: {
                                    marginBottom: 10
                                },
                                children: "Please complete the verification to continue"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Recaptcha_RecaptchaModal__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                onVerify: function(token) {
                                    return handleCheckboxVerify(token);
                                },
                                onError: function() {
                                    setShowCheckboxFallback(false);
                                    setShowError(true);
                                },
                                onClose: function() {
                                    return setShowCheckboxFallback(false);
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                style: {
                                    marginTop: 8,
                                    textAlign: "right"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    className: "px-4 py-2 text-sm",
                                    onClick: function() {
                                        setShowCheckboxFallback(false);
                                    },
                                    children: "Cancel"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var JoinTheEvryNetwork = function() {
    (0,_hooks_useRecaptchaLoader__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), disabledField = ref[0], setDisabledField = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showError = ref1[0], setShowError = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showSuccess = ref2[0], setShowSuccess = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isSubmitting = ref3[0], setIsSubmitting = ref3[1];
    var reportError = (0,_hooks_useReportError__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)().reportError;
    var toggleModal = function() {
        setShowError(false);
        setShowSuccess(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SEO_SEO__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Layout__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute inset-x-0 bottom-0 bg-gray-100 h-1/2"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mx-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute inset-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                className: "object-cover w-full h-full",
                                                src: "banner/person-on-phone.png",
                                                alt: "Person on the phone"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "relative px-4 py-16 sm:px-6 md:py-32 md:px-80",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                                className: "text-3xl tracking-tight md:text-5xl text-blue-dark",
                                                children: [
                                                    "Join the",
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "block text-globeGreen",
                                                        children: "Evry Network"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "max-w-screen-xl px-12 py-12 mx-auto",
                            children: [
                                showSuccess && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FormSuccessDialog_FormSuccessDialog__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    toggleModal: toggleModal
                                }),
                                showError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FormErrorDialog_FormErrorDialog__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    click: function(e) {
                                        setShowError(false);
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "grid md:grid-cols-2 md:gap-16",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "col-span-1",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                                        className: "pb-10 text-3xl tracking-tight md:text-4xl text-darkBlue",
                                                        children: [
                                                            "Evry's different in every way.",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "block text-blue",
                                                                children: "We're excited to know you."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
                                                        className: "".concat((_styles_section_module_css__WEBPACK_IMPORTED_MODULE_22___default().chekmarkList), " text-lg text-grey font-[sans-serif]"),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "We pride ourselves on delivering world-class customer service and make every interaction simple. Our provider services are just a phone call away."
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "We built one-of-a-kind technology to receive, process and pay claims accurately and on time."
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "We pay claims faster - think hours and days, not weeks."
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "No games. No headaches. Just an amazing experience from start to finish."
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Our members love us because working with Evry is simple, painless and transparent."
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "We have built advanced systems designed to enable your practice to thrive under new reimbursement models."
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        children: "Many additional income opportunities!"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "pl-6",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                            className: "list-disc ",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                        children: "Telehealth"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                        children: "Clinical Teaming"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                        children: "Ingesting medical notes for your patients from other providers"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                        children: "Bonuses for referrals into specialized wellness programs"
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        className: "pb-4 text-3xl font-bold uppercase text-darkBlue",
                                                        children: "Request To Join"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        className: "pb-6 text-sm text-grey",
                                                        children: [
                                                            "Roster updates can also be sent to",
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "mailto:networksupport@evryhealth.com",
                                                                className: "text-green hover:underline",
                                                                children: "networksupport@evryhealth.com"
                                                            }),
                                                            "."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NetworkSupportForm, {
                                                        disabledField: disabledField,
                                                        setDisabledField: setDisabledField,
                                                        isSubmitting: isSubmitting,
                                                        setIsSubmitting: setIsSubmitting,
                                                        showError: showError,
                                                        setShowError: setShowError,
                                                        showSuccess: showSuccess,
                                                        setShowSuccess: setShowSuccess,
                                                        reportError: reportError
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (JoinTheEvryNetwork);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [87,293,875,991,842,774,888,179], function() { return __webpack_exec__(935); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);